var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "form-group" },
      [
        !_vm.isRoot
          ? [
              _c("label", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "workflow.vueFormBuilder.elements.object.model.elements"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("br")
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("small", { staticClass: "text-muted" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "workflow.vueFormBuilder.elements.object.dragToReorderElements"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c(
          "draggable",
          {
            attrs: {
              "item-key": "key",
              handle: ".drag-handle",
              animation: "200"
            },
            model: {
              value: _vm.elements,
              callback: function($$v) {
                _vm.elements = $$v
              },
              expression: "elements"
            }
          },
          _vm._l(_vm.elements, function(element) {
            return _c("div", { key: element.name, staticClass: "card mb-2" }, [
              _c("div", { staticClass: "card-body p-2" }, [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-start" },
                  [
                    _c("DragHandle", {
                      staticClass: "ml-2 mt-1 mr-3 drag-handle"
                    }),
                    _vm._v(" "),
                    _c("ElementGeneral", {
                      staticClass: "flex-grow-1",
                      attrs: {
                        builderElement: element,
                        collapsed: !_vm.expanded.includes(element.name)
                      },
                      on: {
                        toggleCollapse: function($event) {
                          return _vm.toggleCollapse(element.name)
                        },
                        remove: function($event) {
                          return _vm.removeField(element.name)
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          }),
          0
        )
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mb-3" }, [
      _c("label", [
        _vm._v(
          _vm._s(_vm.$t("workflow.vueFormBuilder.elements.object.addElement"))
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-group" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newType,
                expression: "newType"
              }
            ],
            staticClass: "form-control",
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.newType = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          _vm._l(_vm.typeOptions, function(option) {
            return _c(
              "option",
              { key: option.value, domProps: { value: option.value } },
              [_vm._v(_vm._s(option.label))]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.newName,
              expression: "newName"
            }
          ],
          staticClass: "form-control",
          attrs: {
            placeholder: _vm.$t(
              "workflow.vueFormBuilder.elements.general.model.name"
            )
          },
          domProps: { value: _vm.newName },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.newName = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.newLabel,
              expression: "newLabel"
            }
          ],
          staticClass: "form-control",
          attrs: {
            placeholder: _vm.$t(
              "workflow.vueFormBuilder.elements.general.model.label"
            )
          },
          domProps: { value: _vm.newLabel },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.newLabel = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "input-group-append" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-success",
              attrs: { disabled: !_vm.canAdd },
              on: { click: _vm.addField }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t("workflow.vueFormBuilder.elements.object.add")
                  ) +
                  "\n        "
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }